<div>
    <div *ngIf="spinner==true">
        <ngx-spinner  size="medium"  type="timer" >
            <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
        </ngx-spinner>
      </div>
    <div class="login-page">
        <div class="card card-outline mx-auto" style="width: 95%; max-width: 600px;">
            <div class="login-logo text-center mt-2">
                <a class="welcome-text">Welcome to <b>MyRoots</b> Portal</a>
                <div class="flex-grow-1 d-flex justify-content-center">
                    <img src="assets/dmk.png" style="width: 100px; height: auto;" alt="MyRoots Logo">
                  </div>
            </div>
            <div class="card-body login-card-body">
                <form [formGroup]="verifyOtpForm" (ngSubmit)="verifyOtp()">
                    <div class="form-group d-flex align-items-center flex-wrap">
                        <label class="mr-3">Enter OTP<span style="color: red;font-weight: bold;">*</span></label>
                        <input type="text" formControlName="otp" class="form-control otp-input" (input)="onInput($event)" maxlength="6">
                        <button class="btn btn-primary btn-submit submit" type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

 